"use client";

import { ApolloProvider } from "@apollo/client";
import { MantineProvider } from "@mantine/core";
import type { FC, ReactNode } from "react";
import { useMemo } from "react";
import { Notifications } from "@/components/ui/parts";
import {
  hydrateAccessTokenFromServer,
  makeClient,
} from "@/libs/apollo/provider";

import { customTheme } from "@/styles/theme";

type Props = {
  children: ReactNode;
  authToken: string | null;
};

export const Provider: FC<Props> = ({ children, authToken }) => {
  // authTokenが変わるたびにApolloClientを作り直すと、リフレッシュ後に全クエリが再起動して無限ローディングになる。
  // authToken は SSR 用。サーバーではモジュール変数を使わず、このクライアントに閉じた値で認証する
  const client = useMemo(() => makeClient({ authToken }), []);
  hydrateAccessTokenFromServer(authToken);

  return (
    <ApolloProvider client={client}>
      <MantineProvider theme={customTheme()}>
        {children}
        <Notifications />
      </MantineProvider>
    </ApolloProvider>
  );
};
